var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.4668 6.66588L6.795 9.55135C7.0447 9.71781 7.16955 9.80105 7.30463 9.86001C7.42452 9.91235 7.55016 9.95039 7.67894 9.97335C7.82404 9.99921 7.97409 9.99921 8.2742 9.99921H13.3261C13.6262 9.99921 13.7762 9.99921 13.9213 9.97335C14.0501 9.95039 14.1757 9.91235 14.2956 9.86001C14.4307 9.80105 14.5556 9.71781 14.8053 9.55135L19.1335 6.66588M6.4668 17.4992H15.1335C16.5336 17.4992 17.2337 17.4992 17.7684 17.2267C18.2388 16.987 18.6213 16.6046 18.861 16.1342C19.1335 15.5994 19.1335 14.8993 19.1335 13.4992V8.16588C19.1335 6.76575 19.1335 6.06568 18.861 5.5309C18.6213 5.0605 18.2388 4.67805 17.7684 4.43836C17.2337 4.16588 16.5336 4.16588 15.1335 4.16588H6.4668C5.06667 4.16588 4.3666 4.16588 3.83182 4.43836C3.36142 4.67805 2.97896 5.0605 2.73928 5.5309C2.4668 6.06568 2.4668 6.76575 2.4668 8.16588V13.4992C2.4668 14.8993 2.4668 15.5994 2.73928 16.1342C2.97896 16.6046 3.36142 16.987 3.83182 17.2267C4.3666 17.4992 5.06667 17.4992 6.4668 17.4992Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.459422bb6f448be814570e4b870190d1.svg";
export { ForwardRef as ReactComponent };